import React from "react";
import { isEqual } from "lodash";
import { Redirect } from "react-router";

import Input from "components/Input";
import Loading from "components/Loading";
import Select from "components/Input/Select";
import InfoTooltip from "components/InfoTooltip";
import Tooltip from "components/Tooltip";

import searchIcon from "assets/images/icons/search.svg";

import classes from "./style.module.scss";

export default React.memo(
    ({
        children,
        tabs = [],
        tabActive,
        onChange,
        type = "",
        className,
        tabNavClassName,
        title,
        withSearch,
        inputClasses,
        searchOnChange,
        searchValue,
        isLoading,
        isNotActiveTabLabel,
        filteredTabs,
        hasOrganization,
        showOrganizationUpgrades,
        setShowOrganizationUpgrades,
        dropdownTitle,
        dropdownOptions,
        dropdownInput,
        activeTabClassName,
        tabLabelClassName,
        hideActiveTabStyle,
        collapsed = false,
        onToggleCollapsed,
    }) => {
        if (!isLoading && !isEqual(tabActive, "/") && !tabs.map((tab) => tab.url).includes(tabActive)) {
            return <Redirect to={"/404-page-not-found"} />;
        }

        return (
            <div className={`${classes.tabs} ${className ? className : ""}`}>
                <div
                    className={`${classes.tabNav} ${collapsed ? classes.collapsed : ""} ${
                        type === "subTabs" ? classes.subTabs : ""
                    } ${tabNavClassName ? tabNavClassName : ""}`}
                >
                    <div className={classes.stickyContainer}>
                        {onToggleCollapsed ? (
                            <div className={`${classes.navHeader} ${collapsed ? classes.navHeaderCollapsed : ""}`}>
                                {!collapsed && title ? <h3>{title}</h3> : null}
                                <button
                                    type="button"
                                    className={`${classes.collapseToggle} ${collapsed ? classes.collapseToggleCollapsed : ""}`}
                                    aria-label={collapsed ? "Expand navigation" : "Collapse navigation"}
                                    aria-expanded={!collapsed}
                                    onClick={onToggleCollapsed}
                                >
                                    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true">
                                        <path
                                            d="M7 2L1 8L7 14"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        ) : (
                            title && <h3>{title}</h3>
                        )}

                        {dropdownTitle && (
                            <div className={inputClasses ? inputClasses : ""}>
                                <Select options={dropdownOptions} input={dropdownInput} />
                            </div>
                        )}
                        {withSearch && (
                            <div className={inputClasses ? inputClasses : ""}>
                                <Input
                                    input={{
                                        value: searchValue,
                                        onChange: (e) => searchOnChange(e),
                                    }}
                                    icon={searchIcon}
                                />
                            </div>
                        )}
                        <ul>
                            {isLoading ? (
                                <div>
                                    <Loading />
                                </div>
                            ) : withSearch ? (
                                filteredTabs.map(
                                    ({ name, url = "", disabled, icon, className: tabClass, minWidth = "0rem" }, index) => {
                                        const activeTab = url;
                                        const isActive = activeTab === tabActive && !hideActiveTabStyle;

                                        return (
                                            <li
                                                key={index}
                                                disabled={disabled}
                                                className={`${isActive ? classes.active : ""} ${tabClass ? tabClass : ""}`}
                                                onClick={(e) => (!disabled ? onChange(url) : null)}
                                                style={{ minWidth: minWidth }}
                                            >
                                                <span>
                                                    {icon && <img src={icon} alt={name} />} {name}
                                                </span>
                                            </li>
                                        );
                                    }
                                )
                            ) : (
                                tabs.map(
                                    (
                                        {
                                            name,
                                            url = "",
                                            disabled,
                                            icon,
                                            className: tabClass,
                                            minWidth = "0rem",
                                            IconComp,
                                            info = "",
                                        },
                                        index
                                    ) => {
                                        const activeTab = url;
                                        const isActive = activeTab === tabActive && !hideActiveTabStyle;

                                        return (
                                            <li
                                                key={index}
                                                disabled={disabled}
                                                className={`${isActive ? classes.active : ""} ${isActive && activeTabClassName ? activeTabClassName : ""} ${tabClass ? tabClass : ""}`}
                                                onClick={(e) => (!disabled ? onChange(url) : null)}
                                                style={{ minWidth: collapsed ? 0 : minWidth }}
                                                data-tip={collapsed ? name : undefined}
                                                data-for={collapsed ? `vertical-tab-${index}` : undefined}
                                            >
                                                <span className={tabLabelClassName}>
                                                    {icon && <img src={icon} alt={name} />}
                                                    {IconComp && <IconComp />}
                                                    {collapsed ? null : name}
                                                    {!collapsed && info ? (
                                                        <InfoTooltip className={classes.infoTooltip} info={info} />
                                                    ) : null}
                                                </span>
                                                {collapsed ? <Tooltip id={`vertical-tab-${index}`} /> : null}
                                            </li>
                                        );
                                    }
                                )
                            )}
                        </ul>
                    </div>
                </div>
                {tabActive === "/" && isNotActiveTabLabel ? (
                    <h2 className={classes.isNotActiveTab}>{isNotActiveTabLabel}</h2>
                ) : (
                    <div className={classes.tab}>
                        {React.Children.map(children, (child, index) => {
                            const { url = "" } = tabs[index] || {};

                            const activeTab = url;
                            const isActive = activeTab === tabActive;

                            if (!isActive) {
                                return null;
                            }

                            return child;
                        })}
                    </div>
                )}
            </div>
        );
    }
);
